exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "scene-preview .scene{position:relative;background-color:#fff}scene-preview .scene img{position:absolute;object-fit:cover!important;background:#d3d3d3}scene-preview .scene img.no-bg{background:none}scene-preview .scene .scene-bg,scene-preview .scene .scene-overlay{position:absolute;background-size:100% 100%;background-position:50% 50%;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/common/scene-preview/scene-preview.scss
// module id = 719
// module chunks = 0